import { initializeApp } from "firebase/app";
const firebaseConfig = {
    apiKey: "AIzaSyAAlCD244WiSuBtgsS-SL1kQMPtmn1hZME",
    authDomain: "portfolio-5712a.firebaseapp.com",
    databaseURL: "https://portfolio-5712a-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "portfolio-5712a",
    storageBucket: "portfolio-5712a.appspot.com",
    messagingSenderId: "861317495791",
    appId: "1:861317495791:web:62fee8f1237d764e81d41a",
    measurementId: "G-G8J14GFQ9G"
  };
  // Your Firebase configuration

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
